import React from "react";
import PropTypes from "prop-types";
import Select from "../BaseControls/Select";
import ControlTemplate from "../BaseControls/ControlTemplate";
import { controlPropTypes } from "../formhelpers";

export default class Recordbrowser extends React.Component {
    constructor(props) {
        super(props);
        this.onRecordbrowserClick = this.onRecordbrowserClick.bind(this);
    }

    onRecordbrowserClick(e) {
        const {onRecordbrowserClick, descriptor} = this.props;
        onRecordbrowserClick && onRecordbrowserClick(e, descriptor);
    }

    render() {
        const {options, descriptor, isLoading, enabled} = this.props;
        const config = descriptor.config || {};
        const showRecordBrowserIcon = config.showRecordBrowserIcon == null || config.showRecordBrowserIcon;
        return (
            <ControlTemplate {...this.props} className="association-field" >
                <div className={showRecordBrowserIcon ? "input-group" : ""}>
                    <Select
                        {...this.props}
                        options={options}
                        valueKey={config.valueKey || "name"}
                        labelKey={config.labelKey || "display"}
                        addMissing={true}
                    />
                    {showRecordBrowserIcon && enabled && <span className="input-group-addon record_browser_icon_container" onClick={this.onRecordbrowserClick}>
                        <span className="glyphicon glyphicon-search icon-search" />
                    </span>}
                    {isLoading && <div className="local-over-modal">Searching...</div>}
                </div>
            </ControlTemplate>
        );
    }
}

Recordbrowser.propTypes = {
    ...controlPropTypes({
        otherEntityKey: PropTypes.string.isRequired,
        autoSelectOnlyOption: PropTypes.bool,
        showRecordBrowserIcon: PropTypes.bool
    }),
    onRecordbrowserClick: PropTypes.func,
    isLoading: PropTypes.bool,
};



// WEBPACK FOOTER //
// ./app/lib/common/descriptorcontrols/AssociationField/recordbrowser.js